(function () {
  'use strict';

  var STATUS = {
    '0': { title: 'RETURNED', note: 'This parcel is being returned to the sender.', icon: 'returned' },
    '1': { title: 'NOT FOUND', note: 'The carrier has not published tracking information yet.', icon: 'not-found' },
    '2': { title: 'SHIPMENT CREATED', note: 'The carrier has received the shipment details.', icon: 'created' },
    '3': { title: 'IN TRANSIT', note: 'Your parcel is moving through the carrier network.', icon: 'transit' },
    '4': { title: 'OUT FOR DELIVERY', note: 'Your parcel is on its final journey to you.', icon: 'out-for-delivery' },
    '5': { title: 'READY FOR PICKUP', note: 'Your parcel is ready to collect.', icon: 'pickup' },
    '6': { title: 'DELIVERED', note: 'Your parcel has been delivered.', icon: 'delivered' },
    '7': { title: 'TRACKING ENDED', note: 'The carrier has closed this tracking journey.', icon: 'ended' },
    '8': { title: 'DELIVERY FAILED', note: 'The carrier could not complete the latest delivery attempt.', icon: 'failed' },
    '9': { title: 'DELIVERY EXCEPTION', note: 'The carrier has reported an exception. Please review the latest update.', icon: 'exception' }
  };

  function clearNode(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function normalizeIdentifier(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function validOrderNumber(value) {
    return /^#?[A-Z0-9-]{3,30}$/.test(value);
  }

  function validTrackingNumber(value) {
    return /^[A-Z0-9-]{6,40}$/.test(value);
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 254;
  }

  function timezoneSuffix(value) {
    var zone = String(value || '').trim();
    if (!zone) return '';
    if (/^[+-]\d{2}$/.test(zone)) return zone + ':00';
    if (/^[+-]\d{4}$/.test(zone)) return zone.slice(0, 3) + ':' + zone.slice(3);
    if (/^[+-]\d{2}:\d{2}$/.test(zone)) return zone;
    return '';
  }

  function checkpointEpoch(checkpoint) {
    var raw = String(checkpoint && checkpoint.time || '').trim();
    if (!raw) return 0;
    var isoLike = raw.replace(' ', 'T');
    if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(isoLike)) isoLike += timezoneSuffix(checkpoint.timezone);
    var parsed = Date.parse(isoLike);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function displayTime(checkpoint) {
    var value = String(checkpoint && checkpoint.time || '').replace('T', ' ').trim();
    var zone = String(checkpoint && checkpoint.timezone || '').trim();
    return [value, zone ? 'UTC ' + zone : ''].filter(Boolean).join(' · ');
  }

  function addSummaryItem(summary, label, value, href) {
    if (!value) return;
    var group = document.createElement('div');
    var term = document.createElement('dt');
    var detail = document.createElement('dd');
    var content = href ? document.createElement('a') : document.createElement('span');
    term.textContent = label;
    content.textContent = value;
    if (href) {
      content.href = href;
      content.target = '_blank';
      content.rel = 'noopener noreferrer';
    }
    detail.appendChild(content);
    group.appendChild(term);
    group.appendChild(detail);
    summary.appendChild(group);
  }

  function initialize(section) {
    if (!section || section.dataset.auraTrackingReady === 'true') return;
    section.dataset.auraTrackingReady = 'true';

    var endpoint = section.getAttribute('data-track-endpoint');
    var iconPrefix = section.getAttribute('data-icon-prefix') || '';
    var form = section.querySelector('[data-aura-track-form]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-aura-track-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-aura-track-panel]'));
    var orderInput = section.querySelector('[data-aura-order-input]');
    var emailInput = section.querySelector('[data-aura-email-input]');
    var trackingInput = section.querySelector('[data-aura-tracking-input]');
    var submit = section.querySelector('[data-aura-track-submit]');
    var submitLabel = section.querySelector('[data-aura-track-submit-label]');
    var message = section.querySelector('[data-aura-track-message]');
    var result = section.querySelector('[data-aura-track-result]');
    var statusTitle = section.querySelector('[data-aura-track-status-title]');
    var statusNote = section.querySelector('[data-aura-track-status-note]');
    var summary = section.querySelector('[data-aura-track-summary]');
    var timeline = section.querySelector('[data-aura-track-timeline]');
    var empty = section.querySelector('[data-aura-track-empty]');
    var statusIcon = section.querySelector('[data-aura-track-status-icon]');
    var mode = 'order';
    var requestId = 0;
    var activeController = null;
    var resetTimer = null;

    if (!form || !tabs.length || !endpoint) return;

    function setMessage(text, state) {
      message.textContent = text || '';
      if (state) message.setAttribute('data-state', state);
      else message.removeAttribute('data-state');
    }

    function resetSubmit() {
      if (resetTimer) window.clearTimeout(resetTimer);
      resetTimer = null;
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      submit.removeAttribute('data-state');
      submitLabel.textContent = 'TRACK ORDER';
    }

    function replaceTrackingParam(value) {
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.delete('tracking');
      if (value) pageUrl.searchParams.set('tracking', value);
      window.history.replaceState({}, '', pageUrl.toString());
    }

    function cancelActiveRequest() {
      requestId += 1;
      if (activeController) activeController.abort();
      activeController = null;
      resetSubmit();
    }

    function setMode(nextMode, focusField) {
      cancelActiveRequest();
      mode = nextMode === 'tracking' ? 'tracking' : 'order';
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-aura-track-tab') === mode;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-aura-track-panel') !== mode;
      });
      result.hidden = true;
      setMessage('', '');
      if (mode === 'order') replaceTrackingParam('');
      if (focusField) (mode === 'order' ? orderInput : trackingInput).focus();
    }

    function render(payload) {
      clearNode(summary);
      clearNode(timeline);
      empty.hidden = true;

      if (!payload.found) {
        result.hidden = true;
        setMessage(payload.message || 'No tracking information is available yet.', 'error');
        return false;
      }

      var level = payload.status && payload.status.level1 != null ? String(payload.status.level1) : '';
      var status = STATUS[level] || {
        title: 'TRACKING UPDATE',
        note: 'Your latest carrier update appears below.',
        icon: 'update'
      };
      statusTitle.textContent = status.title;
      statusNote.textContent = status.note;
      if (statusIcon && iconPrefix) statusIcon.setAttribute('href', '#' + iconPrefix + status.icon);
      result.setAttribute('data-status-icon', status.icon);

      var checkpoints = Array.isArray(payload.checkpoints) ? payload.checkpoints.slice() : [];
      checkpoints = checkpoints.map(function (checkpoint, index) {
        return { checkpoint: checkpoint || {}, originalIndex: index, epoch: checkpointEpoch(checkpoint || {}) };
      }).sort(function (left, right) {
        if (left.epoch && right.epoch && left.epoch !== right.epoch) return right.epoch - left.epoch;
        return left.originalIndex - right.originalIndex;
      }).map(function (entry) { return entry.checkpoint; });

      addSummaryItem(summary, 'ORDER', payload.orderNumber);
      addSummaryItem(summary, 'TRACKING', payload.trackingNumber);
      addSummaryItem(summary, 'LATEST UPDATE', checkpoints.length ? displayTime(checkpoints[0]) : 'AWAITING SCAN');
      summary.style.setProperty('--aura-summary-count', String(Math.max(1, summary.children.length)));

      if (!checkpoints.length) {
        empty.hidden = false;
      } else {
        checkpoints.forEach(function (checkpoint) {
          var item = document.createElement('li');
          item.className = 'crux-aura-track__checkpoint';

          var marker = document.createElement('span');
          marker.className = 'crux-aura-track__marker';
          marker.setAttribute('aria-hidden', 'true');

          var content = document.createElement('div');
          var time = document.createElement('time');
          var heading = document.createElement('h3');
          var detail = document.createElement('p');

          time.textContent = displayTime(checkpoint) || 'Tracking update';
          heading.textContent = checkpoint.message || 'Shipment update';
          detail.textContent = checkpoint.location || '';

          content.appendChild(time);
          content.appendChild(heading);
          if (detail.textContent) content.appendChild(detail);
          item.appendChild(marker);
          item.appendChild(content);
          timeline.appendChild(item);
        });
      }

      result.hidden = false;
      setMessage('', '');
      return true;
    }

    async function track() {
      var body;
      if (mode === 'order') {
        var orderNumber = normalizeIdentifier(orderInput.value);
        var email = normalizeEmail(emailInput.value);
        if (!validOrderNumber(orderNumber) || !validEmail(email)) {
          result.hidden = true;
          setMessage('Enter a valid order number and checkout email.', 'error');
          (!validOrderNumber(orderNumber) ? orderInput : emailInput).focus();
          return;
        }
        body = { mode: 'order', orderNumber: orderNumber, email: email };
      } else {
        var trackingNumber = normalizeIdentifier(trackingInput.value);
        if (!validTrackingNumber(trackingNumber)) {
          result.hidden = true;
          setMessage('Enter a valid tracking number.', 'error');
          trackingInput.focus();
          return;
        }
        trackingInput.value = trackingNumber;
        body = { mode: 'tracking', trackingNumber: trackingNumber };
      }

      cancelActiveRequest();
      var currentRequest = requestId;
      activeController = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (activeController) activeController.abort();
      }, 20000);

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = 'SEARCHING…';
      result.hidden = true;
      setMessage('Finding your jewelry journey…', 'loading');

      try {
        var requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        };
        if (activeController) requestOptions.signal = activeController.signal;
        var response = await fetch(endpoint, requestOptions);
        var payload;
        try {
          payload = await response.json();
        } catch (parseError) {
          throw new Error('Tracking service returned an invalid response.');
        }
        if (currentRequest !== requestId) return;
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'Tracking information could not be retrieved.');

        var complete = render(payload.data || {});
        if (mode === 'tracking') replaceTrackingParam(body.trackingNumber);
        else replaceTrackingParam('');

        if (complete) {
          submitLabel.textContent = 'TRACKING FOUND';
          submit.setAttribute('data-state', 'success');
          resetTimer = window.setTimeout(resetSubmit, 1500);
          window.requestAnimationFrame(function () {
            result.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        } else {
          resetSubmit();
        }
      } catch (error) {
        if (currentRequest !== requestId) return;
        result.hidden = true;
        if (error && error.name === 'AbortError') {
          setMessage('The search took too long. Please try again.', 'error');
        } else {
          setMessage(error && error.message ? error.message : 'Tracking service is temporarily unavailable.', 'error');
        }
        resetSubmit();
      } finally {
        window.clearTimeout(timeout);
        if (currentRequest === requestId) activeController = null;
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      track();
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setMode(tab.getAttribute('data-aura-track-tab'), true);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        tabs[(index + direction + tabs.length) % tabs.length].click();
      });
    });

    var initialTracking = new URL(window.location.href).searchParams.get('tracking');
    if (initialTracking) {
      setMode('tracking', false);
      trackingInput.value = normalizeIdentifier(initialTracking);
      track();
    } else {
      setMode('order', false);
    }
  }

  function initializeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-crux-aura-track-order]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
